export default __webpack_public_path__ + "static/7i-be7f3d32a138ba64b9d04fa3a87d4eaa.woff";